import classNames from "classnames";
import { FC } from "react";

export const POWERED_BY = "Groupe PI";

interface IProps {
  className?: string;
}

const PoweredBy: FC<IProps> = ({ className }) => (
  <span className={classNames("formalys-powered-by", className)}>
    powered by <strong>{POWERED_BY}</strong>
  </span>
);

export default PoweredBy;
